import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../../app/security/authentication.service';
import { addHourToDate } from '../../utils/date.utils';
import { TimezoneService } from './timezone.service';
import * as moment from 'moment-timezone';

@Injectable({ providedIn: 'root' })
export class TimeZoneConverter {
  timezone: string = this.timezoneService.getTimezone();
  constructor(private readonly authenticationService: AuthenticationService, private readonly timezoneService: TimezoneService) {
  }

  timeZoneMap: Map<string, string> = new Map([['DGS', this.timezone]]);
  private readonly refineryCode =
    this.authenticationService.getcurrentUserRoles();
  timeZone =
    this.timeZoneMap.get(this.refineryCode ? this.refineryCode[0] : 'DGS') ??
    this.timezone;

  convertUTCHourToRefineryTZ(hour: string): string {
    return addHourToDate(moment().format(), hour).toLocaleTimeString(
      'fr-FR',
    );
  }

  convertUTCDateToRefineryTZ(date: string | null): string {
    if (date === null) {
      return '';
    }
    return new Date(date).toLocaleTimeString('fr-FR');
  }
}
